import React, { useState, useEffect } from "react";
import "hammerjs";
import { notification, Spin, Tooltip } from "antd";
import { Modal } from 'antd';
// import "./Dashboard.css";
import { useNavigate } from "react-router";
import { RiHome6Line } from "react-icons/ri";
import logo from "../../utilities/logo.png";
import Header from "./Header";
import SideBar from "./SideBar";
import { IoLogOutOutline } from "react-icons/io5";
import { API_URL } from "../../environment";

const Layout = ({ children }) => {
  const history = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("home");
  const role = localStorage.getItem("role");
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };  

  useEffect(() => {
    if (
      window?.location?.pathname == "/myprofile" ||
      window?.location?.pathname == "/changepassword" ||
      window?.location?.pathname == "/editprofile"
    ) {
      setActive("profile");
    } else {
      setActive("home");
    }
  }, []);

  const handleHome = () => {
    setActive("home");
    if (role == "subadmin") {
      history("/hrdashboard");
    } else {
      history("/dashboard");
    }
  };

  const handleLogout  = () => {
    const attId = localStorage.getItem("attId");
    const token = localStorage.getItem("token");
    const PunchIn = localStorage.getItem("PunchIn");
    if (PunchIn == "true") {
      fetch(`${API_URL}attendance/checkout?attendanceId=${attId}`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }).then(async (res) => {
        const respose = await res.json();
        if (respose.success == true) {
          
          notification.success({ message: "PunchOut Successfully!" });
          localStorage.clear();
          history("/");
          notification.success({
            message: "Logout Successfully",
          });

        } else {
          notification.error({
            message: "UnAuthorized",
            description: "Login Again! PunchOut Manually",
          });
          localStorage.clear();
          history("/");
          notification.success({
            message: "Logout Successfully",
          });
        }
      });
    } else {
      history("/");
      notification.success({
        message: "Logout Successfully",
      });
      localStorage.clear();
    }
  };
  return (
    <>
      <div className="mainwrapper_index">
        <div className="all_flex">
          <div className="w80 h-100 ">
            <div className="flex_cols">
              <ul className="ulclass ">
                <li className="mb-4">
                  <img className="logo_fav" src={logo} />
                </li>
                <Tooltip placement="right" title="Home">
                  <li
                    onClick={() => {
                      handleHome();
                    }}
                    className={`${active == "home" ? "active_li" : ""}`}
                  >
                    <RiHome6Line />
                  </li>
                </Tooltip>
              </ul>
              

              <div className="seetings_list text-center">
                <ul className="ulclass">
                <Tooltip placement="right" title="Logout">
                    <li
                      
                      onClick={() => {
                        Modal.confirm({
                          title: "Confirm Logout",
                          content: "Are you sure you want to logout?",
                          okText: "Yes",
                          cancelText: "No",
                          onOk: () => {
                            handleLogout()
                          },
                        });
                      }}
                      className={`${active == "profile logout-wrapper" ? "" : ""}`}
                    >
                     <IoLogOutOutline className="text-xl" />
                    </li>
                  </Tooltip>
                  {/* <Tooltip placement="right" title="Profile">
                    <li
                      onClick={() => {
                        setActive("profile");
                        history("/myprofile");
                      }}
                      className={`${active == "profile" ? "active_li" : ""}`}
                    >
                      <img
                        className="seting_logo"
                        src="assets/img/avatar/avatar-4.png"
                      />
                    </li>
                  </Tooltip> */}
                </ul>
              </div>
              
            </div>
          </div>
          <div
            className={`wraptwos ${
              isOpen ? "open inner_wraps_close" : " inner_wraps"
            }`}
          >
            <div className="d-flex align-items-center bordrs_btn p-2">
              <p className="subheads p-2">
                {active == "profile" ? "Settings" : "Home"}
              </p>
            </div>

            <div className="allilists w-100">
              <SideBar active={active} setActive={setActive} />
            </div>
          </div>

          <div className="main_contents ">
            <div className="header_top">
              <div className="d-flex align-items-center justify-content-between w-100 bordrs_btn px-3">
                <div
                  className={`hamburger ${isOpen ? "open" : ""}`}
                  onClick={toggleMenu}
                >
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                </div>
                <div className="">
                  <Header />
                </div>
              </div>
            </div>

            <div className="childins_data">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Layout;
